import Firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

let firebaseApp = null;

// Load config at runtime
export async function initializeFirebase() {
    if (firebaseApp) return firebaseApp;

    try {
        const response = await fetch('/env.json', { cache: "no-cache" });
        if (!response.ok) throw new Error("Failed to load /env.json");

        const config = await response.json();

        const firebaseConfig = {
            apiKey: config.FIREBASE_API_KEY,
            authDomain: config.FIREBASE_AUTH_DOMAIN,
            databaseURL: config.FIREBASE_DB_URL,
            projectId: config.FIREBASE_PROJECT_ID,
            storageBucket: config.FIREBASE_STORAGE_BUCKET,
        };

        firebaseApp = Firebase.initializeApp(firebaseConfig);
        const loadedProjectId = Firebase.app().options.projectId;

        console.log("[FIREBASE INIT] Using project ID:", loadedProjectId);
        window.firebase = Firebase; // Optional for console inspection

        const expectedProject = resolveExpectedProjectId(window.location.hostname);
        if (expectedProject && loadedProjectId !== expectedProject) {
            throw new Error(`[FIREBASE INIT ERROR] Expected project "${expectedProject}", but got "${loadedProjectId}"`);
        }

        setupAuthStateListener();
        return firebaseApp;

    } catch (err) {
        console.error("[FIREBASE INIT] Failed to initialize Firebase:", err);
        throw err;
    }
}

// Dynamically check expected project based on current hostname
function resolveExpectedProjectId(hostname) {
    if (hostname.includes("train")) return "ms-ops-dev"; // firebase dev is hosted on clouldfront train env
    if (hostname.includes("test")) return "ms-ops-test-86dbc";
    if (hostname === "ms-ops.net") return "ms-ops-production";
    return null;
}

function setupAuthStateListener() {
    const auth = Firebase.auth();

// Listen to User's Auth State
    auth.onAuthStateChanged((user) => {
        const userEl = document.getElementById('user');

        if (user && !user.emailVerified) {
            console.log('User is logged in, but email is not verified');
        } else if (user && user.emailVerified) {
            console.log('User is logged in and email is verified!');
        } else {
            console.log('User is signed out.');
        }

        if (user) {
            // User is signed in, so see if they need to be logged out for exceeding session limit
            user.getIdTokenResult().then((idTokenResult) => {

                // get user's authentication timestamp in milliseconds
                const authTime = idTokenResult.claims.auth_time * 1000;
                const sessionDuration = 7 * 24 * 60 * 60 * 1000; // 1 week
                // const sessionDuration = 5 * 60 * 1000; // 5 minutes limit in milliseconds for TESTING

                // if user was authenticated more than the session duration limit, log them out
                if (Date.now() - authTime > sessionDuration) {
                    console.log("User has exceeded the session limit and must be logged out.");
                    auth.signOut();
                } else {
                    console.log("User has not exceeded session limit and may stay logged in.");
                }
            });
        }
    });
}
